module.exports = __webpack_public_path__ + "assets/img/img-14.d7b99f7a.png";